export class ImportErpOrderNFeXmlInput {
  orderId: number;
  formData: FormData;
}
